import { addTag, tagDels } from "@/apis/tags";
import { ItemLabelEnum, TagLabel } from "@/types/common"
import { PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Input, notification, Popover, Tag } from "antd"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next";


interface WmsTagsProps {
  refId: string;
  refType: ItemLabelEnum;
  tags: Array<TagLabel>;
  onDelSucc?: (id: string) => void;
  onAddSucc?: (newTag: TagLabel) => void;
};

const labelColors = [
  "magenta", "red", "volcano", "orange", "gold", "lime", "green", "cyan", "blue", "geekblue", "purple"
];
const getColor = (id: string) => labelColors[(id || '99').charCodeAt(0) % labelColors.length];

const WmsTags: FC<WmsTagsProps> = ({ refId, refType, tags, onDelSucc, onAddSucc }) => {
  const { t } = useTranslation();
  const [tagDatas, setTagDatas] = useState<Array<TagLabel & { color: string }>>(() =>
    tags.map(tag => ({ ...tag, color: getColor(tag.id) }))
  );
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [tagText, setTagText] = useState<string>('');

  const handleAddTag = () => {
    if (!!!tagText) return
    setLoading(true);
    addTag({ refId, refType, tag: tagText })
      .then(res => {
        setTagDatas(last => [{ ...res, color: getColor(res.id) }, ...last]);
        setTagText('');
        setOpenAdd(false)
        onAddSucc?.(res)
      })
      .catch(() => {
        notification.error({ message: t('common.addError') })
      })
      .finally(() => setLoading(false))
  }
  const handleDelTag = (id: string) => {
    tagDels([id])
      .then(() => {
        setTagDatas(last => last.filter(t => t.id !== id))
        onDelSucc?.(id)
      })
      .catch(() => {
        notification.error({ message: t('common.rmError') })
      })
  }

  const handleCloseInput = () => {
    setOpenAdd(false);
    setTagText('');
  }

  const content = openAdd && (
    <Flex gap={2} vertical>
      <Input autoFocus value={tagText} onChange={e => setTagText(e.target.value)} onPressEnter={handleAddTag} />
      <Flex gap={4} justify="flex-end">
        <Button onClick={handleCloseInput}>{t('common.cancel')}</Button>
        <Button type="primary" onClick={handleAddTag} loading={loading}>{t('common.confirm')}</Button>
      </Flex>
    </Flex>
  )

  const addTrigger = (
    <Tag icon={<PlusOutlined />} style={{ cursor: "pointer" }} onClick={openAdd ? undefined : () => setOpenAdd(true)}>
      {t('common.add')}
    </Tag>
  );

  return (
    <Flex style={{ width: "100%" }} gap={4} wrap>
      {
        tagDatas.map(tag => (
          <Tag key={tag.id} color={tag.color} closable onClose={(e) => {
            e.preventDefault();
            handleDelTag(tag.id);
          }}>{tag.tag}</Tag>
        ))
      }
      {openAdd ? (
        <Popover title={t('common.add')} content={content} open onOpenChange={setOpenAdd} trigger="click">
          {addTrigger}
        </Popover>
      ) : addTrigger}
    </Flex>
  )
};

export default WmsTags;
